import { gql, type TypedDocumentNode } from '@apollo/client';

/**
 * The explicit Candidate opt-in (Company module Stage 1 decision: registration creates only an
 * ACCOUNT — becoming a Candidate is a deliberate choice). One transaction server-side: creates the
 * TalentProfile and grants the `Candidate` role; idempotent for an account that already opted in.
 * The caller must refresh the auth session afterwards — the new role lives in the access token.
 */
export const BECOME_CANDIDATE: TypedDocumentNode<{
  becomeCandidate: {
    profile: { id: string; userId: string } | null;
    errors: { code: string; message: string }[];
  };
}> = gql`
  mutation BecomeCandidate {
    becomeCandidate {
      profile {
        id
        userId
      }
      errors {
        code
        message
      }
    }
  }
`;
